import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useLocation } from "react-router-dom";
import FromFieldText from '../../../atoms/FromFieldText';
import FromMoveListAs from '../../../molecules/FromMoveListAs';
import MultiListPopUpAs from '../../../atoms/MultiListPopUpAs';
import FromMoveListIndAs from '../../../molecules/FromMoveListIndAs';
import FromMoveListBothAsIndAs from '../../../molecules/FromMoveListBothAsIndAs';
import FromMoveList2 from '../../../molecules/FromMoveList2';
import FromMoveExceptionList from '../../../molecules/FromMoveExceptionList';
import { getDepreciationAssetCount, getWithoutExcepTagsList, getExceptionCapitalized } from '../../../services/asset.service'
import * as CryptoJS from "crypto-js";
import './AssetInfo.css';

export default function AssetGenrateDepreciation() {
  const [financeInfo, setFinanceInfo] = useState(false);
  const [assetPopDisplayAs, setAssetPopDisplayAs] = useState(false);
  const [assetsDataAs, setAssetsDataAs] = useState([]);
  const [assetPopDisplayIndAs, setAssetPopDisplayIndAs] = useState(false);
  const [assetsDataIndAs, setAssetsDataIndAs] = useState([]);
  const [assetsContAs, setAssetsCountAs] = useState(0);
  const [totalAs, setTotalAs] = useState(0);
  const [assetsContIndAs, setAssetsCountIndAs] = useState(0);
  const [totalIndAs, setTotalIndAs] = useState(0);
  const [assetPopDisplayBothAsIndAs, setAssetPopDisplayBothAsIndAs] = useState(false);
  const [assetsDataBothAsIndAs, setAssetsDataBothAsIndAs] = useState([]);
  const [assetPopDisplay2, setAssetPopDisplay2] = useState(false);
  const [assetsData2, setAssetsData2] = useState([]);
  const [assetPopDisplay3, setAssetPopDisplay3] = useState(false);
  const [exceptionData, setExceptionData] = useState([]);
  const [back_url, setBackUrl] = useState(false);
  
  // Progress and loading states
  const [loadingAs, setLoadingAs] = useState(false);
  const [progress, setProgress] = useState(0);
  const [total, setTotal] = useState(0);
  
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const Finance = query.get('finance');

  // 1. Decrypt Finance only when it changes
  useEffect(() => {
    if (Finance && Finance !== '') {
      const decryptedBytes = CryptoJS.AES.decrypt(
        Finance.replace(/ /g, '+'),
        process.env.REACT_APP_ENCRYPT_SECRET_KEY
      );
      const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
      setBackUrl(decrypt_data?.back_url + '?previous=' + Finance);
      setFinanceInfo(decrypt_data);
      
    }
  }, [Finance]);

  // 2. Fetch general asset data (only once on mount or when token changes)
  useEffect(() => {
    const EncryptData = CryptoJS.AES.encrypt(
      JSON.stringify({
        param_data: { month: financeInfo.finance_month },
        authToken: sessionStorage.getItem('LoggedInToken'),
      }),
      process.env.REACT_APP_ENCRYPT_SECRET_KEY
    ).toString();
    
    const oData = { token: EncryptData };
  }, []);

  // 3. Fetch exception data when financeInfo.finance_month becomes available
  useEffect(() => { //alert(financeInfo?.finance_month);
    if (financeInfo?.finance_month) {
      const EncryptData1 = CryptoJS.AES.encrypt(
        JSON.stringify({
          param_data: { month: financeInfo.finance_month, year: financeInfo.finance_year },
          authToken: sessionStorage.getItem('LoggedInToken'),
        }),
        process.env.REACT_APP_ENCRYPT_SECRET_KEY
      ).toString();

      const oData1 = { token: EncryptData1 };
      getExceptionCapitalized(oData1).then((res) => {
        if (res?.data?.data?.length) {
          setExceptionData(res.data.data);
        }
      });
      getWithoutExcepTagsList(oData1).then((res) => {
        if (res?.data?.data?.length) {
          setAssetsDataAs(res.data.data);
          setAssetsDataIndAs(res.data.data);
          setAssetsDataBothAsIndAs(res.data.data);
          setAssetsData2(res.data.data);
        }
      });
      getDepreciationAssetCount(oData1).then((res) => { 
        if (res?.data?.total_dep_as) { //console.log(res.data.total_dep_as);
          setAssetsCountAs(res.data.total_dep_as);
          setAssetsCountIndAs(res.data.total_dep_indas);
          //setAssetsCountBothAsIndAs(res.data.data);
          
        }
      });
    }
  }, [financeInfo.finance_month]);

  function getMonthName(monthNumber) { //alert(monthNumber);
    const month = Number(monthNumber); // force number
    if (month < 1 || month > 12) return "Invalid month";
    let full_month = new Date(2000, month - 1, 1).toLocaleString('en-US', {
      month: 'long'
    });
    //alert(full_month);
    return full_month;
  }
  // Calculate percentage
  const percentage = total > 0 ? Math.round((progress / total) * 100) : 0;
  
  // Debug logs
  useEffect(() => {
    console.log('Parent state updated - Progress:', progress, 'Total:', total, 'Loading:', loadingAs);
  }, [progress, total, loadingAs]);

  return (
    <div className='container-fluid' style={{ backgroundColor: '#f5f7fa', minHeight: '100vh', padding: '30px' }}>
      {/* Loading Overlay - Enhanced */}
      {loadingAs && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '50px',
            borderRadius: '16px',
            textAlign: 'center',
            minWidth: '450px',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            animation: 'fadeIn 0.3s ease-in'
          }}>
            <div className="spinner-border text-primary" role="status" style={{ 
              width: '4rem', 
              height: '4rem', 
              marginBottom: '25px',
              borderWidth: '4px'
            }}>
              <span className="visually-hidden">Loading...</span>
            </div>
            <h4 style={{ marginBottom: '15px', color: '#2c3e50', fontWeight: '600' }}>
              <i className="bi bi-gear-fill" style={{ marginRight: '10px', color: '#007bff' }}></i>
              Generating Depreciation for {getMonthName(financeInfo.finance_month)}-{financeInfo.finance_year}
            </h4>
            <p style={{ fontSize: '20px', fontWeight: 'bold', color: '#007bff', marginBottom: '20px' }}>
              {progress} of {total} Assets Generated
            </p>
            <div style={{
              width: '100%',
              height: '35px',
              backgroundColor: '#e9ecef',
              borderRadius: '20px',
              overflow: 'hidden',
              marginBottom: '20px',
              boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <div style={{
                width: `${percentage}%`,
                height: '100%',
                background: 'linear-gradient(90deg, #007bff 0%, #0056b3 100%)',
                transition: 'width 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '15px',
                boxShadow: '0 2px 4px rgba(0, 123, 255, 0.4)'
              }}>
                {percentage}%
              </div>
            </div>
            <div style={{
              padding: '12px',
              backgroundColor: '#e7f3ff',
              borderRadius: '8px',
              border: '1px solid #b3d9ff'
            }}>
              <p style={{ fontSize: '14px', color: '#0056b3', margin: 0, fontWeight: '500' }}>
                <i className="bi bi-info-circle-fill" style={{ marginRight: '6px' }}></i> 
                Please don't refresh the page until the process is completed
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Header Section - Enhanced */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '15px 20px',
        marginBottom: '30px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        border: '1px solid #e9ecef'
      }}>
        <div className='row align-items-center'>
          <div className="col-lg-5 col-md-12 mb-3 mb-lg-0">
            <h3 style={{ 
              margin: 0, 
              fontSize: '1.45rem', 
              fontWeight: '700',
              color: '#2c3e50',
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <i className="bi bi-calculator-fill" style={{ color: '#007bff' }}></i>
              Generate Depreciation
            </h3>
          </div>
          
          <div className="col-lg-2 col-md-6 mb-3 mb-lg-0">
            <div style={{
              padding: '12px 20px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '2px solid #e9ecef'
            }}>
              <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px', fontWeight: '500' }}>
                <i className="bi bi-calendar-month"></i> MONTH
              </div>
              <div style={{ fontSize: '16px', fontWeight: '700', color: '#2c3e50' }}>
                {getMonthName(financeInfo.finance_month)}
              </div>
            </div>
          </div>
          
          <div className="col-lg-2 col-md-6 mb-3 mb-lg-0">
            <div style={{
              padding: '12px 20px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              border: '2px solid #e9ecef'
            }}>
              <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '4px', fontWeight: '500' }}>
                <i className="bi bi-calendar-event"></i> YEAR
              </div>
              <div style={{ fontSize: '16px', fontWeight: '700', color: '#2c3e50' }}>
                {financeInfo.finance_year}
              </div>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-12 text-lg-end">
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
              <a href={back_url} className='btn btn-outline-secondary' style={{
                borderRadius: '8px',
                padding: '10px 20px',
                fontWeight: '500',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px'
              }}>
                <i className="bi bi-arrow-left"></i> Back
              </a>
              <a className='btn btn-outline-primary' href='' style={{
                borderRadius: '8px',
                padding: '10px 20px',
                fontWeight: '500',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px'
              }}>
                <i className="bi bi-arrow-clockwise"></i> Refresh
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Depreciation Cards Section */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '30px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        border: '1px solid #e9ecef'
      }}>
        {/* Table Header */}
        <div className="row" style={{
          padding: '15px 20px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          marginBottom: '20px',
          fontWeight: '600',
          color: '#495057',
          border: '1px solid #dee2e6'
        }}>
          <div className="col-lg-6 col-md-5">
            <i className="bi bi-card-list"></i> DEPRECIATION TYPE
          </div>
          <div className="col-lg-3 col-md-3">
            <i className="bi bi-activity"></i> STATUS
          </div>
          <div className="col-lg-3 col-md-4">
            <i className="bi bi-lightning-fill"></i> ACTION
          </div>
        </div>
        
        {/* Depreciation Row 1 - I-GAAP AS */}
        <div className="row align-items-center" style={{
          padding: '20px',
          marginBottom: '15px',
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          border: '1px solid #e9ecef',
          transition: 'all 0.3s ease',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff';
        }}>
          <div className="col-lg-6 col-md-5 mb-2 mb-md-0">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '40px',
                height: '40px',
                backgroundColor: '#e7f3ff',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <i className="bi bi-graph-up" style={{ color: '#007bff', fontSize: '20px' }}></i>
              </div>
              <div>
                <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '15px' }}>
                  I-GAAP Depreciation SLM
                </div>
                <div style={{ fontSize: '13px', color: '#6c757d' }}>
                  Year Wise - Month wise [Only For AS]
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-3 mb-2 mb-md-0">
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
    {/* Generated Badge - Only show if count > 0 */}
    {assetsContAs > 0 && (
      <span style={{
        padding: '6px 16px',
        backgroundColor: '#d1e7dd',
        color: '#0f5132',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: '600',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        border: '1px solid #badbcc',
        width: 'fit-content'
      }}>
        <i className="bi bi-check-circle-fill"></i>
        Generated: {assetsContAs}
      </span>
    )}
    
    {/* Not Generated Badge - Only show if count > 0 */}
    {(assetsDataAs.length - assetsContAs) > 0 && (
      <span style={{
        padding: '6px 16px',
        backgroundColor: '#fff3cd',
        color: '#856404',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: '600',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        border: '1px solid #ffecb5',
        width: 'fit-content'
      }}>
        <i className="bi bi-clock-history"></i>
        Pending: {assetsDataAs.length - assetsContAs}
      </span>
    )}
    
    {/* All Complete Badge - Show when all generated */}
    {assetsContAs > 0 && (assetsDataAs.length - assetsContAs) === 0 && (
      <span style={{
        padding: '6px 16px',
        backgroundColor: '#d1e7dd',
        color: '#0f5132',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: '600',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        border: '1px solid #badbcc',
        width: 'fit-content'
      }}>
        <i className="bi bi-check-circle-fill"></i>
        All Complete ({assetsContAs})
      </span>
    )}
    
    {/* No Assets Badge - Show when no assets */}
    {assetsDataAs.length === 0 && (
      <span style={{
        padding: '6px 16px',
        backgroundColor: '#e2e3e5',
        color: '#383d41',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: '600',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        border: '1px solid #d3d6d8',
        width: 'fit-content'
      }}>
        <i className="bi bi-inbox"></i>
        No Assets
      </span>
    )}
  </div>
</div>
          
          <div className="col-lg-3 col-md-4">
            <FromMoveListAs
              labelAs="I-GAAP Depreciation SLM Year Wise - Month wise [Only For AS]" 
              showPopUpAs={assetPopDisplayAs} 
              setShowPopUpAs={setAssetPopDisplayAs} 
              dataAs={assetsDataAs} 
              datasetterAs={setAssetsDataAs}
              setLoadingAs={setLoadingAs}
              setProgress={setProgress}
              setTotal={setTotal}
            />
          </div>
        </div>
        
        {/* Depreciation Row 2 - I-GAAP Ind AS */}
        <div className="row align-items-center" style={{
          padding: '20px',
          marginBottom: '15px',
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          border: '1px solid #e9ecef',
          transition: 'all 0.3s ease',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff';
        }}>
          <div className="col-lg-6 col-md-5 mb-2 mb-md-0">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '40px',
                height: '40px',
                backgroundColor: '#d4edda',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <i className="bi bi-graph-up-arrow" style={{ color: '#28a745', fontSize: '20px' }}></i>
              </div>
              <div>
                <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '15px' }}>
                  I-GAAP Depreciation SLM
                </div>
                <div style={{ fontSize: '13px', color: '#6c757d' }}>
                  Year Wise - Month wise [Only For Ind AS]
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-3 mb-2 mb-md-0">
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
    {/* Generated Badge - Only show if count > 0 */}
    {assetsContIndAs > 0 && (
      <span style={{
        padding: '6px 16px',
        backgroundColor: '#d1e7dd',
        color: '#0f5132',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: '600',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        border: '1px solid #badbcc',
        width: 'fit-content'
      }}>
        <i className="bi bi-check-circle-fill"></i>
        Generated: {assetsContIndAs}
      </span>
    )}
    
    {/* Not Generated Badge - Only show if count > 0 */}
    {(assetsDataIndAs.length - assetsContIndAs) > 0 && (
      <span style={{
        padding: '6px 16px',
        backgroundColor: '#fff3cd',
        color: '#856404',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: '600',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        border: '1px solid #ffecb5',
        width: 'fit-content'
      }}>
        <i className="bi bi-clock-history"></i>
        Pending: {assetsDataIndAs.length - assetsContIndAs}
      </span>
    )}
    
    {/* All Complete Badge - Show when all generated */}
    {assetsContIndAs > 0 && (assetsDataIndAs.length - assetsContIndAs) === 0 && (
      <span style={{
        padding: '6px 16px',
        backgroundColor: '#d1e7dd',
        color: '#0f5132',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: '600',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        border: '1px solid #badbcc',
        width: 'fit-content'
      }}>
        <i className="bi bi-check-circle-fill"></i>
        All Complete ({assetsContIndAs})
      </span>
    )}
    
    {/* No Assets Badge - Show when no assets */}
    {assetsDataIndAs.length === 0 && (
      <span style={{
        padding: '6px 16px',
        backgroundColor: '#e2e3e5',
        color: '#383d41',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: '600',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        border: '1px solid #d3d6d8',
        width: 'fit-content'
      }}>
        <i className="bi bi-inbox"></i>
        No Assets
      </span>
    )}
  </div>
</div>
          
          <div className="col-lg-3 col-md-4">
            <FromMoveListIndAs
              labelIndAs="I-GAAP Depreciation SLM Year Wise - Month wise [Only For Ind AS]" 
              showPopUpIndAs={assetPopDisplayIndAs} 
              setShowPopUpIndAs={setAssetPopDisplayIndAs} 
              dataIndAs={assetsDataIndAs} 
              datasetterIndAs={setAssetsDataIndAs}
              setLoadingAs={setLoadingAs}
              setProgress={setProgress}
              setTotal={setTotal}
            />
          </div>
        </div>
        
        {/* Depreciation Row 3 - Both AS & Ind AS */}
        <div className="row align-items-center" style={{
          padding: '20px',
          marginBottom: '15px',
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          border: '1px solid #e9ecef',
          transition: 'all 0.3s ease',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff';
        }}>
          <div className="col-lg-6 col-md-5 mb-2 mb-md-0">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '40px',
                height: '40px',
                backgroundColor: '#cfe2ff',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <i className="bi bi-bar-chart-line-fill" style={{ color: '#0d6efd', fontSize: '20px' }}></i>
              </div>
              <div>
                <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '15px' }}>
                  I-GAAP Depreciation SLM
                </div>
                <div style={{ fontSize: '13px', color: '#6c757d' }}>
                  Year Wise - Month wise [Both AS & Ind AS]
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-3 mb-2 mb-md-0">
            <span style={{
              padding: '6px 16px',
              backgroundColor: '#fff3cd',
              color: '#856404',
              borderRadius: '20px',
              fontSize: '13px',
              fontWeight: '600',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px'
            }}>
              <i className="bi bi-clock-history"></i>
              Not generated
            </span>
          </div>
          
          <div className="col-lg-3 col-md-4">
            <FromMoveListBothAsIndAs
              labelBothAsIndAs="I-GAAP Depreciation SLM Year Wise - Month wise [Both AS & Ind AS]" 
              showPopUpBothAsIndAs={assetPopDisplayBothAsIndAs} 
              setShowPopUpBothAsIndAs={setAssetPopDisplayBothAsIndAs} 
              dataBothAsIndAs={assetsDataBothAsIndAs} 
              datasetterBothAsIndAs={setAssetsDataBothAsIndAs}
            />
          </div>
        </div>
        
        {/* Depreciation Row 4 - Other GAAP */}
        <div className="row align-items-center" style={{
          padding: '20px',
          marginBottom: '15px',
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          border: '1px solid #e9ecef',
          transition: 'all 0.3s ease',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff';
        }}>
          <div className="col-lg-6 col-md-5 mb-2 mb-md-0">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '40px',
                height: '40px',
                backgroundColor: '#e2d9f3',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <i className="bi bi-pie-chart-fill" style={{ color: '#6f42c1', fontSize: '20px' }}></i>
              </div>
              <div>
                <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '15px' }}>
                  Other GAAP Depreciation SLM
                </div>
                <div style={{ fontSize: '13px', color: '#6c757d' }}>
                  Year Wise Only - Month Wise
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-3 mb-2 mb-md-0">
            <span style={{
              padding: '6px 16px',
              backgroundColor: '#fff3cd',
              color: '#856404',
              borderRadius: '20px',
              fontSize: '13px',
              fontWeight: '600',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px'
            }}>
              <i className="bi bi-clock-history"></i>
              Not generated
            </span>
          </div>
          
          <div className="col-lg-3 col-md-4">
            <FromMoveList2
              label2="Other GAAP Depreciation SLM Year Wise Only - Month Wise" 
              showPopUp2={assetPopDisplay2} 
              setShowPopUp2={setAssetPopDisplay2} 
              data2={assetsData2} 
              datasetter2={setAssetsData2} 
            />
          </div>
        </div>
        
        {/* Depreciation Row 5 - Exception Tags */}
        <div className="row align-items-center" style={{
          padding: '20px',
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          border: '1px solid #e9ecef',
          transition: 'all 0.3s ease',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff';
        }}>
          <div className="col-lg-6 col-md-5 mb-2 mb-md-0">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{
                width: '40px',
                height: '40px',
                backgroundColor: '#f8d7da',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <i className="bi bi-exclamation-triangle-fill" style={{ color: '#dc3545', fontSize: '20px' }}></i>
              </div>
              <div>
                <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '15px' }}>
                  Exception Tags Depreciation SLM
                </div>
                <div style={{ fontSize: '13px', color: '#6c757d' }}>
                  Year Wise - Month wise - AS
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-lg-3 col-md-3 mb-2 mb-md-0">
            <span style={{
              padding: '6px 16px',
              backgroundColor: '#fff3cd',
              color: '#856404',
              borderRadius: '20px',
              fontSize: '13px',
              fontWeight: '600',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px'
            }}>
              <i className="bi bi-clock-history"></i>
              Not generated
            </span>
          </div>
          
          <div className="col-lg-3 col-md-4">
            <FromMoveExceptionList
              label3="Exception Tags Depreciation SLM Year Wise - Month wise - AS" 
              showPopUp3={assetPopDisplay3} 
              setShowPopUp3={setAssetPopDisplay3} 
              exceptionData={exceptionData} 
              datasetter3={setExceptionData}
            />
          </div>
        </div>
      </div>

      {/* Optional: Info Footer */}
      <div style={{
        marginTop: '25px',
        padding: '20px',
        backgroundColor: '#e7f3ff',
        borderRadius: '10px',
        border: '1px solid #b3d9ff',
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        <i className="bi bi-info-circle-fill" style={{ fontSize: '24px', color: '#0056b3' }}></i>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: '600', color: '#004085', marginBottom: '4px' }}>
            Important Information
          </div>
          <div style={{ fontSize: '14px', color: '#004085' }}>
            Select the depreciation type and click "Continue" to process assets. The system will automatically calculate depreciation based on your selection.
          </div>
        </div>
      </div>
    </div>
  )
}